
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cLD3i", function(module, exports) {

$parcel$export(module.exports, "TestId", () => $1c29116e9d0757b6$export$f067415f668a97e9);
$parcel$export(module.exports, "i18n", () => $1c29116e9d0757b6$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "DialogPillName", () => $1c29116e9d0757b6$export$88ed889099de593c);
$parcel$export(module.exports, "pillToLoadingTextI18n", () => $1c29116e9d0757b6$export$fd1cbc4568cecf9e);
$parcel$export(module.exports, "dialogToPageAnalyticsTab", () => $1c29116e9d0757b6$export$262e9e4f2cc23d74);

var $2nPZH = parcelRequire("2nPZH");

var $5xN4O = parcelRequire("5xN4O");
var $1c29116e9d0757b6$export$f067415f668a97e9 = /*#__PURE__*/ function(TestId) {
    TestId["DIALOG"] = "analytics-dialog";
    // CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
    TestId["DIALOG_SKELETON"] = "analytics-dialog-skeleton";
    TestId["LINK"] = "analytics-link";
    TestId["LINK_SKELETON"] = "analytics-link-skeleton";
    TestId["CLOSE_BUTTON"] = "dialog-close-button";
    TestId["PILLS"] = "analytics-pills";
    TestId["INFO_PANEL_1"] = "analytics-info-panel-1";
    TestId["INFO_PANEL_2"] = "analytics-info-panel-2";
    TestId["CHART"] = "analytics-chart";
    TestId["USER_LIST"] = "analytics-user-list";
    return TestId;
}({});
const $1c29116e9d0757b6$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    dialogContainerAriaLabel: {
        id: "confluence-analytics.dialog.container-aria-label",
        defaultMessage: "Confluence Analytics"
    },
    dialogLoadingText: {
        id: "confluence-analytics.dialog.loading",
        defaultMessage: "Loading data..."
    },
    dialogLoadingTextMentioned: {
        id: "confluence-analytics.dialog.loading.mentioned",
        defaultMessage: "Loading mentions data..."
    },
    dialogMentionedUsersViewed: {
        id: "confluence-analytics.dialog.mentioned-users-viewed",
        defaultMessage: "mentioned {seenMentionedUsersCount, plural, one {user} other {users}} viewed this page"
    },
    dialogMentionedUsersAllSeen: {
        id: "confluence-analytics.dialog.mentioned-users-all-seen",
        defaultMessage: "Everyone mentioned has viewed"
    },
    dialogProgressbarCountAriaLabel: {
        id: "confluence-analytics.dialog.progress-bar.count-aria-label",
        defaultMessage: "{seenMentionedUsersCount} of {totalMentionedUsersCount} mentioned {seenMentionedUsersCount, plural, one {user} other {users}} viewed this page"
    },
    dialogProgressbarAriaLabel: {
        id: "confluence-analytics.dialog.progress-bar-aria-label",
        defaultMessage: "Mentioned users progress bar"
    },
    graphGranularityWeek: {
        id: "confluence-analytics.graph.granularity.week",
        defaultMessage: "Week of {date}"
    },
    graphCreatedAtDateTimeLabel: {
        id: "confluence-analytics.graph.label.created-at",
        defaultMessage: "Created {date} at {time}"
    },
    graphDateToDateTimeLabel: {
        id: "confluence-analytics.graph.label.date-to-datetime",
        defaultMessage: "{fromDate} to {toDate} ({toTime})"
    },
    lastViewedJustNow: {
        id: "confluence-analytics.dialog.viewers-list.viewed-just-now",
        defaultMessage: "Just now"
    },
    lastViewedMinutesAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-minutes-ago",
        defaultMessage: "{minuteCount} {minuteCount, plural, one {minute} other {minutes}} ago"
    },
    lastViewedHoursAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-hours-ago",
        defaultMessage: "{hourCount} {hourCount, plural, one {hour} other {hours}} ago"
    },
    lastViewedDaysAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-days-ago",
        defaultMessage: "{dayCount} {dayCount, plural, one {day} other {days}} ago"
    },
    lastViewedWeeksAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-weeks-ago",
        defaultMessage: "{weekCount} {weekCount, plural, one {week} other {weeks}} ago"
    },
    lastViewedMonthsAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-months-ago",
        defaultMessage: "{monthCount} {monthCount, plural, one {month} other {months}} ago"
    },
    lastViewedYearsAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-years-ago",
        defaultMessage: "{yearCount} {yearCount, plural, one {year} other {years}} ago"
    },
    errorMessage: {
        id: "confluence-analytics.dialog.loading.error-message",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble loading analytics."
    },
    errorSuggestion: {
        id: "confluence-analytics.dialog.loading.error-suggestion",
        defaultMessage: "Refresh to try again."
    },
    viewedMentionsLabel: {
        id: "confluence-analytics.dialog.mentions-list.viewed.label",
        defaultMessage: "Viewed"
    },
    notViewedMentionsLabel: {
        id: "confluence-analytics.dialog.mentions-list.not-viewed.label",
        defaultMessage: "Not viewed"
    },
    mentionedPeopleLabel: {
        id: "confluence-analytics.dialog.mentions-list.mentioned-people.label",
        defaultMessage: "Mentioned people"
    },
    linksTabTopInboundColumnHeaderLabel: {
        id: "confluence-analytics.dialog.links-tab.inbound.column-header",
        defaultMessage: "Top Inbound Links"
    },
    linksTabTopOutboundColumnHeaderLabel: {
        id: "confluence-analytics.dialog.links-tab.outbound.column-header",
        defaultMessage: "Top Outbound Links"
    },
    linksTabClicksColumnHeaderLabel: {
        id: "confluence-analytics.dialog.links-tab.clicks.column-header",
        defaultMessage: "Clicks"
    },
    linksTabViewAllLinkLabel: {
        id: "confluence-analytics.dialog.links-tab.view-all-link",
        defaultMessage: "View all"
    },
    linksTabViewMoreButtonLabel: {
        id: "confluence-analytics.dialog.links-tab.view-more-button",
        defaultMessage: "View more insights"
    },
    linksTabNoInboundLinksMessage: {
        id: "confluence-analytics.dialog.links-tab.no-inbound-links",
        defaultMessage: "No other pages reference this page. As this page draws traffic from other sources, those links will appear here."
    },
    linksTabNoOutboundLinksMessage: {
        id: "confluence-analytics.dialog.links-tab.no-outbound-links",
        defaultMessage: "There are no outbound links on this page. When you add one, you can track its click count here."
    },
    linksTabExternalLinkContentItem: {
        id: "confluence-analytics.dialog.links-tab.external-link-content-item",
        defaultMessage: "External links"
    },
    linksTabExternalLinkContentItemInfoTooltip: {
        id: "confluence-analytics.dialog.links-tab.external-link-content-item.info.tooltip",
        defaultMessage: "Only aggregated data is available for external site links."
    },
    linksTabExternalLinkContentItemInfoTooltipLabel: {
        id: "confluence-analytics.dialog.links-tab.external-link-content-item.info.tooltip-label",
        defaultMessage: "External links tooltip button"
    },
    linksTabErrorContentItem: {
        id: "confluence-analytics.dialog.links-tab.error-content-item",
        defaultMessage: "An error occurred while loading this link. Refresh the page to try again."
    }
});
var $1c29116e9d0757b6$export$88ed889099de593c = /*#__PURE__*/ function(DialogPillName) {
    DialogPillName["VIEWS"] = "views";
    DialogPillName["MENTIONS"] = "mentions";
    DialogPillName["LINKS"] = "links";
    return DialogPillName;
}({});
const $1c29116e9d0757b6$export$fd1cbc4568cecf9e = {
    ["views"]: $1c29116e9d0757b6$export$a7357cdd1f0b0168.dialogLoadingText,
    ["mentions"]: $1c29116e9d0757b6$export$a7357cdd1f0b0168.dialogLoadingTextMentioned,
    ["links"]: $1c29116e9d0757b6$export$a7357cdd1f0b0168.dialogLoadingText
};
const $1c29116e9d0757b6$export$262e9e4f2cc23d74 = {
    ["views"]: (0, $5xN4O.PageAnalyticsTab).Overview,
    ["mentions"]: (0, $5xN4O.PageAnalyticsTab).Mentions,
    ["links"]: (0, $5xN4O.PageAnalyticsTab).Links
};

});
parcelRegister("5xN4O", function(module, exports) {

$parcel$export(module.exports, "PageAnalyticsTab", () => $d8466874f27a53b3$export$8f7cddb6b4959a67);
$parcel$export(module.exports, "PageAnalyticsLinksSubTab", () => $d8466874f27a53b3$export$1f41de6a41b77790);
$parcel$export(module.exports, "PageAnalyticsGASv3EventName", () => $d8466874f27a53b3$export$69b114bcc0e2f59f);
$parcel$export(module.exports, "PAGE_ANALYTICS_SCREEN_ANALYTICS_SOURCE", () => $d8466874f27a53b3$export$b8f6c7f789b2671);
$parcel$export(module.exports, "PAGE_ANALYTICS_SCREEN_ANALYTICS_LEVEL", () => $d8466874f27a53b3$export$a5ce587de9137469);
$parcel$export(module.exports, "PAGE_ANALYTICS_UPSELL_SCREEN_ANALYTICS_SOURCE", () => $d8466874f27a53b3$export$249c4c36eaa9e255);
$parcel$export(module.exports, "PAGE_ANALYTICS_TABS_UI_ID", () => $d8466874f27a53b3$export$e0ebacb36e8d64a3);
$parcel$export(module.exports, "EXPLORE_ANALYTICS_URL", () => $d8466874f27a53b3$export$7274bd955f07efa1);
$parcel$export(module.exports, "UPGRADE_URL", () => $d8466874f27a53b3$export$a32d9d8578eb1f45);
$parcel$export(module.exports, "UPSELL_LINK_ACTION_SUBJECT", () => $d8466874f27a53b3$export$1d20b2eb25ef0e7d);
$parcel$export(module.exports, "UPSELL_BUTTON_ACTION_SUBJECT", () => $d8466874f27a53b3$export$222e8adb166f1410);
$parcel$export(module.exports, "UPSELL_LINK_ACTION_SUBJECT_ID", () => $d8466874f27a53b3$export$f475dda9a272223f);
$parcel$export(module.exports, "UPSELL_BUTTON_ACTION_SUBJECT_ID", () => $d8466874f27a53b3$export$25ed7d81cdd878a9);
$parcel$export(module.exports, "MENTIONED_USERS_CONTENT_TEST_ID", () => $d8466874f27a53b3$export$18b62fb5bd5d82ca);
$parcel$export(module.exports, "TOTAL_VIEWS_CONTENT_TEST_ID", () => $d8466874f27a53b3$export$b3e36e6261d37c01);
$parcel$export(module.exports, "TOTAL_CLICKS_CONTENT_TEST_ID", () => $d8466874f27a53b3$export$fea01d822d834d6e);
$parcel$export(module.exports, "UNIQUE_VIEWERS_CONTENT_TEST_ID", () => $d8466874f27a53b3$export$81c55753a7f14223);
$parcel$export(module.exports, "VIEWERS_TABLE_TEST_ID", () => $d8466874f27a53b3$export$6f99f9ba2f55c502);
$parcel$export(module.exports, "MENTIONED_USERS_TABLE_TEST_ID", () => $d8466874f27a53b3$export$71dc078607dc79ff);
$parcel$export(module.exports, "VIEW_CHART_TEST_ID", () => $d8466874f27a53b3$export$daa4cf6a350ae121);
// The order should represent the order in the UI
var $d8466874f27a53b3$export$8f7cddb6b4959a67 = /*#__PURE__*/ function(PageAnalyticsTab) {
    PageAnalyticsTab[PageAnalyticsTab["Overview"] = 0] = "Overview";
    PageAnalyticsTab[PageAnalyticsTab["Mentions"] = 1] = "Mentions";
    PageAnalyticsTab[PageAnalyticsTab["Links"] = 2] = "Links";
    return PageAnalyticsTab;
}({});
var $d8466874f27a53b3$export$1f41de6a41b77790 = /*#__PURE__*/ function(PageAnalyticsLinksSubTab) {
    PageAnalyticsLinksSubTab["Outbound"] = "outbound";
    PageAnalyticsLinksSubTab["Inbound"] = "inbound";
    return PageAnalyticsLinksSubTab;
}({});
const $d8466874f27a53b3$export$69b114bcc0e2f59f = {
    [0]: 'views',
    [1]: 'mentions',
    [2]: 'links'
};
const $d8466874f27a53b3$export$b8f6c7f789b2671 = 'analyticsPageScreen';
const $d8466874f27a53b3$export$a5ce587de9137469 = 'page';
const $d8466874f27a53b3$export$249c4c36eaa9e255 = 'pageAnalyticsScreen';
const $d8466874f27a53b3$export$e0ebacb36e8d64a3 = 'page-analytics-tabs';
const $d8466874f27a53b3$export$7274bd955f07efa1 = 'https://support.atlassian.com/confluence-cloud/docs/view-insights-on-pages/';
const $d8466874f27a53b3$export$a32d9d8578eb1f45 = '/admin/billing/applications/change-edition/confluence.ondemand';
const $d8466874f27a53b3$export$1d20b2eb25ef0e7d = 'link';
const $d8466874f27a53b3$export$222e8adb166f1410 = 'button';
const $d8466874f27a53b3$export$f475dda9a272223f = 'exploreAnalytics';
const $d8466874f27a53b3$export$25ed7d81cdd878a9 = 'tryItFree';
const $d8466874f27a53b3$export$18b62fb5bd5d82ca = 'page-analytics-mentioned-users-growth-card-content';
const $d8466874f27a53b3$export$b3e36e6261d37c01 = 'page-analytics-total-views';
const $d8466874f27a53b3$export$fea01d822d834d6e = 'page-analytics-total-clicks';
const $d8466874f27a53b3$export$81c55753a7f14223 = 'page-analytics-unique-viewers';
const $d8466874f27a53b3$export$6f99f9ba2f55c502 = 'page-analytics-viewers-table';
const $d8466874f27a53b3$export$71dc078607dc79ff = 'page-analytics-mentioned-users-table';
const $d8466874f27a53b3$export$daa4cf6a350ae121 = 'page-analytics-view-chart';

});


parcelRegister("auSj5", function(module, exports) {

$parcel$export(module.exports, "getViewersCount", () => $2897f8d10319544e$export$9453b552a0dd9f7d);
$parcel$export(module.exports, "isInternalUser", () => $2897f8d10319544e$export$6e5fbcef55ead47f);
$parcel$export(module.exports, "isSSRError", () => $2897f8d10319544e$export$7370b6e65675fd29);
$parcel$export(module.exports, "isExpectedError", () => $2897f8d10319544e$export$8715824c16ceeca0);
$parcel$export(module.exports, "isPermissionError", () => $2897f8d10319544e$export$e11674744930cd15);
$parcel$export(module.exports, "isEditionAllowed", () => $2897f8d10319544e$export$ff1e63df46e36894);
$parcel$export(module.exports, "limitStartDate", () => $2897f8d10319544e$export$928464f4d8995d5);
$parcel$export(module.exports, "getGraphGranularity", () => $2897f8d10319544e$export$ef4ef1ccb99e706e);
$parcel$export(module.exports, "formatDateRange", () => $2897f8d10319544e$export$2e9241a0bdf6c8b8);
$parcel$export(module.exports, "formatInTimeZone", () => $2897f8d10319544e$export$b3ea52468069e196);
$parcel$export(module.exports, "formatGraphDates", () => $2897f8d10319544e$export$232d2af64fd8eba1);
$parcel$export(module.exports, "getLastViewedText", () => $2897f8d10319544e$export$5807416f725a035e);

var $aTqya = parcelRequire("aTqya");

var $4Pzqs = parcelRequire("4Pzqs");
var $4voUZ = parcelRequire("4voUZ");
var $5PE1K = parcelRequire("5PE1K");
var $fXfci = parcelRequire("fXfci");
var $f2RXW = parcelRequire("f2RXW");
var $a5Xto = parcelRequire("a5Xto");
var $haEUY = parcelRequire("haEUY");
var $9KHdj = parcelRequire("9KHdj");
var $8mhsB = parcelRequire("8mhsB");
var $evlvy = parcelRequire("evlvy");

var $9zhXC = parcelRequire("9zhXC");

var $6z5mD = parcelRequire("6z5mD");

var $555nc = parcelRequire("555nc");

var $cLD3i = parcelRequire("cLD3i");
const $2897f8d10319544e$export$9453b552a0dd9f7d = (data)=>data?.contentAnalyticsViewers?.count || 0;
const $2897f8d10319544e$export$6e5fbcef55ead47f = (data)=>data?.user?.confluence?.permissionType === (0, $555nc.SitePermissionType).INTERNAL;
const $2897f8d10319544e$export$7370b6e65675fd29 = (data, error)=>!error && data?.contentAnalyticsViewers === null;
const $2897f8d10319544e$var$PERMISSION_ERROR_CODES = [
    400,
    401,
    403
];
const $2897f8d10319544e$var$CONTENT_ERROR_CODES = [
    404
];
const $2897f8d10319544e$var$capitalizeFirstLetter = (word)=>`${word[0].toLocaleUpperCase()}${word.slice(1)}`;
const $2897f8d10319544e$var$DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
const $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS = {
    hours: {
        dayDiff: 2,
        hourDiff: 48
    },
    days: {
        dayDiff: 28
    },
    weeks: {
        dayDiff: 48
    },
    months: {
        monthDiff: 12
    }
};
const $2897f8d10319544e$var$errorContainsCodes = (error, expectedCodes)=>{
    if ((0, $aTqya.isApolloError)(error)) return error.graphQLErrors.some((e)=>expectedCodes.includes(e?.extensions?.statusCode));
    else return expectedCodes.includes(error?.extensions?.statusCode);
};
const $2897f8d10319544e$export$8715824c16ceeca0 = (error)=>{
    return $2897f8d10319544e$var$errorContainsCodes(error, $2897f8d10319544e$var$PERMISSION_ERROR_CODES) || $2897f8d10319544e$var$errorContainsCodes(error, $2897f8d10319544e$var$CONTENT_ERROR_CODES);
};
const $2897f8d10319544e$export$e11674744930cd15 = (error)=>error && $2897f8d10319544e$var$errorContainsCodes(error, $2897f8d10319544e$var$PERMISSION_ERROR_CODES);
const $2897f8d10319544e$export$ff1e63df46e36894 = (edition)=>edition !== 'FREE';
const $2897f8d10319544e$export$928464f4d8995d5 = (max, contentCreatedDate, baseDate = new Date())=>{
    const earliestPossibleStartDate = $2897f8d10319544e$export$d7c08026d61d9fe2(baseDate, max);
    if ((0, $9KHdj.default)(earliestPossibleStartDate, contentCreatedDate)) return earliestPossibleStartDate;
    return contentCreatedDate;
};
const $2897f8d10319544e$export$d7c08026d61d9fe2 = (today, max)=>{
    return (0, $4Pzqs.default)((0, $evlvy.default)(today, max), {
        days: 1
    });
};
const $2897f8d10319544e$export$ef4ef1ccb99e706e = (createdAtDate)=>{
    const ageOfPageInDays = (0, $4voUZ.default)(new Date(), createdAtDate);
    if (ageOfPageInDays <= $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS.hours.dayDiff) return (0, $6z5mD.AnalyticsTimeseriesGranularity).HOUR;
    else if (ageOfPageInDays <= $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS.days.dayDiff) return (0, $6z5mD.AnalyticsTimeseriesGranularity).DAY;
    else if (ageOfPageInDays <= $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS.weeks.dayDiff) return (0, $6z5mD.AnalyticsTimeseriesGranularity).WEEK;
    return (0, $6z5mD.AnalyticsTimeseriesGranularity).MONTH;
};
const $2897f8d10319544e$var$formatRelativeDate = (date, now = new Date(), locale)=>{
    const relativeDateFormatter = new Intl.RelativeTimeFormat(locale, {
        numeric: 'auto'
    });
    return relativeDateFormatter.format(-(0, $4voUZ.default)(now, date), 'days');
};
const $2897f8d10319544e$var$formatIntlDate = (date, options)=>Intl.DateTimeFormat(undefined, {
        ...options.showMinutes ? {
            minute: 'numeric'
        } : {},
        ...options.showHours ? {
            hour: 'numeric'
        } : {},
        ...options.showDays ? {
            day: 'numeric'
        } : {},
        ...options.showMonths ? {
            month: 'long'
        } : {},
        ...options.showYears ? {
            year: 'numeric'
        } : {},
        hourCycle: 'h12'
    }).format(date);
const $2897f8d10319544e$var$formatSubTextDate = ({ date: date, granularity: granularity, now: now = new Date(), intl: intl })=>{
    switch(granularity){
        case (0, $6z5mD.AnalyticsTimeseriesGranularity).HOUR:
            if ((0, $4voUZ.default)(now, date) < 2) return `${$2897f8d10319544e$var$capitalizeFirstLetter($2897f8d10319544e$var$formatRelativeDate(date, now, intl.locale))}, ${$2897f8d10319544e$var$formatIntlDate(date, {
                showHours: true
            })}`;
            return $2897f8d10319544e$var$formatIntlDate(date, {
                showMonths: true,
                showHours: true,
                showDays: true
            });
        case (0, $6z5mD.AnalyticsTimeseriesGranularity).DAY:
            return $2897f8d10319544e$var$formatIntlDate(date, {
                showMonths: true,
                showDays: true
            });
        case (0, $6z5mD.AnalyticsTimeseriesGranularity).WEEK:
            const formattedIntlDate = $2897f8d10319544e$var$formatIntlDate(date, {
                showMonths: true,
                showDays: true
            });
            return intl.formatMessage((0, $cLD3i.i18n).graphGranularityWeek, {
                date: formattedIntlDate
            });
        default:
            return $2897f8d10319544e$var$formatIntlDate(date, {
                showYears: true,
                showMonths: true
            });
    }
};
const $2897f8d10319544e$export$2e9241a0bdf6c8b8 = ({ fromDate: fromDate, toDate: toDate, now: now = new Date(), intl: intl })=>{
    const hoursFromNow = (0, $fXfci.default)(now, fromDate);
    const formattedDate = (date)=>{
        return $2897f8d10319544e$var$formatIntlDate(date, {
            showMonths: true,
            showDays: true,
            showYears: !(0, $8mhsB.default)(fromDate, toDate)
        });
    };
    const formattedFromTime = $2897f8d10319544e$var$formatIntlDate(fromDate, {
        showHours: true,
        showMinutes: true
    });
    if (hoursFromNow <= 24) {
        const formattedFromDate = $2897f8d10319544e$var$formatRelativeDate(fromDate, now, intl.locale);
        return intl.formatMessage((0, $cLD3i.i18n).graphCreatedAtDateTimeLabel, {
            date: formattedFromDate,
            time: formattedFromTime
        });
    } else if (hoursFromNow < 48) {
        const formattedFromDate = formattedDate(fromDate);
        return intl.formatMessage((0, $cLD3i.i18n).graphCreatedAtDateTimeLabel, {
            date: formattedFromDate,
            time: formattedFromTime
        });
    } else {
        const formattedFromDate = formattedDate(fromDate);
        const formattedToDate = formattedDate(toDate);
        const formattedToTime = $2897f8d10319544e$var$formatRelativeDate(toDate, now, intl.locale);
        return intl.formatMessage((0, $cLD3i.i18n).graphDateToDateTimeLabel, {
            fromDate: formattedFromDate,
            toDate: formattedToDate,
            toTime: formattedToTime
        });
    }
};
const $2897f8d10319544e$export$b3ea52468069e196 = (timeZone, date)=>(0, $9zhXC.format)(date, $2897f8d10319544e$var$DATE_FORMAT, {
        timeZone: timeZone
    });
const $2897f8d10319544e$export$232d2af64fd8eba1 = ({ graphData: graphData, granularity: granularity, now: now = new Date(), intl: intl })=>{
    return graphData.map((graphPoint)=>({
            date: $2897f8d10319544e$var$formatSubTextDate({
                date: new Date(graphPoint.date),
                granularity: granularity,
                now: now,
                intl: intl
            }),
            value: graphPoint.count
        }));
};
const $2897f8d10319544e$export$5807416f725a035e = (lastViewedAt, intl, now = new Date())=>{
    const minutesDiff = (0, $f2RXW.default)(now, lastViewedAt);
    const hoursDiff = (0, $fXfci.default)(now, lastViewedAt);
    const daysDiff = (0, $5PE1K.default)(now, lastViewedAt);
    const monthsDiff = (0, $a5Xto.default)(now, lastViewedAt);
    const yearsDiff = (0, $haEUY.default)(now, lastViewedAt);
    // Less than a minute, return 'now'
    if (minutesDiff < 1) return intl.formatMessage((0, $cLD3i.i18n).lastViewedJustNow);
    // Less than an hour, return minutes
    if (minutesDiff < 60) return intl.formatMessage((0, $cLD3i.i18n).lastViewedMinutesAgo, {
        minuteCount: minutesDiff
    });
    // Less than a day, return hours
    if (hoursDiff < 24) return intl.formatMessage((0, $cLD3i.i18n).lastViewedHoursAgo, {
        hourCount: hoursDiff
    });
    // Less than 31 days, return days
    if (daysDiff < 31) return intl.formatMessage((0, $cLD3i.i18n).lastViewedDaysAgo, {
        dayCount: daysDiff
    });
    // Less than a year, return months
    if (monthsDiff < 12) return intl.formatMessage((0, $cLD3i.i18n).lastViewedMonthsAgo, {
        monthCount: monthsDiff
    });
    // Anything greater than a year just return years
    return intl.formatMessage((0, $cLD3i.i18n).lastViewedYearsAgo, {
        yearCount: yearsDiff
    });
};

});
parcelRegister("haEUY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8031c4996b2ed31$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $hdX0o = parcelRequire("hdX0o");

var $1ZRpX = parcelRequire("1ZRpX");

var $6Z3KL = parcelRequire("6Z3KL");
function $c8031c4996b2ed31$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6Z3KL.default)(2, arguments);
    var dateLeft = (0, $4YLNd.default)(dirtyDateLeft);
    var dateRight = (0, $4YLNd.default)(dirtyDateRight);
    var sign = (0, $1ZRpX.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $hdX0o.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $1ZRpX.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("hdX0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a16bc81b2f14ed$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $c8a16bc81b2f14ed$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6Z3KL.default)(2, arguments);
    var dateLeft = (0, $4YLNd.default)(dirtyDateLeft);
    var dateRight = (0, $4YLNd.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});


parcelRegister("6z5mD", function(module, exports) {

$parcel$export(module.exports, "AnalyticsTimeseriesGranularity", () => $9a177c0c8e5aa505$export$a874c5d67969faf2);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $9a177c0c8e5aa505$export$a874c5d67969faf2 = /*#__PURE__*/ function(AnalyticsTimeseriesGranularity) {
    AnalyticsTimeseriesGranularity["DAY"] = "DAY";
    AnalyticsTimeseriesGranularity["HOUR"] = "HOUR";
    AnalyticsTimeseriesGranularity["MONTH"] = "MONTH";
    AnalyticsTimeseriesGranularity["WEEK"] = "WEEK";
    return AnalyticsTimeseriesGranularity;
}({});

});

parcelRegister("555nc", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $90c7d9d573845ddf$export$8995abb8169b2cb8);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $90c7d9d573845ddf$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});



//# sourceMappingURL=AnalyticsByLine.724cb2a3.js.map
